//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'


const tableStyle = {
    fontSize: 12,
    padding: 3,
}
export default class Summarization extends Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            totalSummarization: props.totalSummarization,
            summarization: props.summarization
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            summarization: nextProps.summarization,
            totalSummarization: nextProps.totalSummarization,
        })
    }

    listSummarizations = () => {
        let items = []
        for (let index in this.state.summarization) {
            let item = this.state.summarization[index]
            items.push(<tr style={tableStyle} key={item.cert_nb}>
                <td style={tableStyle}>{item.date}</td>
                <td style={tableStyle}>{item.certnumber}</td>
                <td style={tableStyle}>{item.cashsum}</td>
                <td style={tableStyle}>{item.bankcardsum}</td>
                <td style={tableStyle}>{item.netto0AJT}</td>
                <td style={tableStyle}>{item.netto0TAM}</td>
                <td style={tableStyle}>{item.netto5}</td>
                <td style={tableStyle}>{item.vat5}</td>
                <td style={tableStyle}>{item.brutto5}</td>
                <td style={tableStyle}>{item.netto18}</td>
                <td style={tableStyle}>{item.vat18}</td>
                <td style={tableStyle}>{item.brutto18}</td>
                <td style={tableStyle}>{item.netto27}</td>
                <td style={tableStyle}>{item.vat27}</td>
                <td style={tableStyle}>{item.brutto27}</td>
            </tr>)
        }
        return items.length ? items : (
            <tr>
                <td colSpan='10'>
                    <h4 className='text-center'>Nincsenek feldolgozott tételek.</h4>
                </td>
            </tr>)

    }

    render() {
        if (!Object.keys(this.state.summarization).length)
            return <h4 className='text-center'>Nincsenek feldolgozott tételek.</h4>

        return (

            <table className='table table-striped  table-aibook-bordered' style={tableStyle}>
                <thead>
                <tr style={tableStyle}>
                    <th style={tableStyle} colSpan='4'>Összesítés</th>
                    <th style={tableStyle}>0%-os AJT áfakulcs</th>
                    <th style={tableStyle}>0%-os TAM áfakulcs</th>
                    <th style={tableStyle} colSpan='3'>5%-os áfakulcs</th>
                    <th style={tableStyle} colSpan='3'>18%-os áfakulcs</th>
                    <th style={tableStyle} colSpan='3'>27%-os áfakulcs</th>
                </tr>
                <tr style={tableStyle}>
                    <th>dátum</th>
                    <th>zárás sorszáma</th>
                    <th>Pénztári fk. összesen</th>
                    <th>Bankkártya T. fk. összesen</th>
                    <th>nettó</th>
                    <th>nettó</th>

                    <th>nettó</th>
                    <th>áfa</th>
                    <th>bruttó</th>

                    <th>nettó</th>
                    <th>áfa</th>
                    <th>bruttó</th>

                    <th>nettó</th>
                    <th>áfa</th>
                    <th>bruttó</th>
                </tr>
                </thead>
                <tbody>
                {this.listSummarizations()}
                <tr style={tableStyle}>
                    <th colSpan='2' className='text-center'>Összesítés:</th>
                    <th>{this.state.totalSummarization.total3811}</th>
                    <th>{this.state.totalSummarization.total3685}</th>
                    <th>{this.state.totalSummarization.totalNet0AJT}</th>
                    <th>{this.state.totalSummarization.totalNet0TAM}</th>

                    <th>{this.state.totalSummarization.totalNet5}</th>
                    <th>{this.state.totalSummarization.totalVat5}</th>
                    <th>{this.state.totalSummarization.totalBrut5}</th>

                    <th>{this.state.totalSummarization.totalNet18}</th>
                    <th>{this.state.totalSummarization.totalVat18}</th>
                    <th>{this.state.totalSummarization.totalBrut18}</th>

                    <th>{this.state.totalSummarization.totalNet27}</th>
                    <th>{this.state.totalSummarization.totalVat27}</th>
                    <th>{this.state.totalSummarization.totalBrut27}</th>

                </tr>
                </tbody>
            </table>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/cashregister/steps/summarization.js